const Defaults = (() => {
  const Language = 'en'
  return {
    Language,
  }
})()

const Services = (() => {
  const Name = 'hubble'
  const Host = `${window.location.protocol}//${window.location.host}`
  const Backend = process.env.VUE_APP_HUBBLE_URL || Host
  const Hosts = {
    App: Backend,
    API: Backend,
    GWT: Backend,
    Vue: Host
  }
  const Paths = {
    App: `/${Name}`,
    API: `/${Name}/api`,
    GWT: `/${Name}/Home`,
    Vue: `/${Name}/2`
  }
  const BaseURLs = {
    App: `${Hosts.App}${Paths.App}`,
    API: `${Hosts.API}${Paths.API}`,
    GWT: `${Hosts.GWT}${Paths.GWT}`,
    Vue: `${Hosts.Vue}${Paths.Vue}`
  }
  return {
    Name,
    Hosts,
    Paths,
    BaseURLs
  }
})()

const ApiSettings = (() => {
  const ApiVersionHeader = 'hubble-api-version' // The header used to tell the API which version to use.
  const ApiVersion = '2.0' // The version of the API to currently use.
  return {
    ApiVersionHeader,
    ApiVersion
  }
})()

const ApiRequests = (() => {
  const allWorkspacesChunk = 20
  return {
    allWorkspacesChunk
  }
})()

const Cookies = (() => {
  const cookieLifeSpan = '1Y'
  const rememberMeCookie = 'remember'
  const i18nLocaleCookie = 'locale'
  const i18nLanguageCookie = 'lang'
  const ExpirationCookie = 'AuthenticationExpirationTicket' // Name of the cookie holding session expiry time
  const ExpirationCookieCheckFrequencySeconds = 10 // Interval in seconds for checking the session expiry cookie
  return {
    Settings: {
      LifeSpan: cookieLifeSpan
    },
    Authentication: {
      RememberMe: rememberMeCookie
    },
    SessionExpiration: {
      Name: ExpirationCookie,
      CheckFrequency: ExpirationCookieCheckFrequencySeconds * 1000 // Convert to miliseconds for export
    },
    i18n: {
      Locale: i18nLocaleCookie,
      Language: i18nLanguageCookie
    }
  }
})()

const Grid = (() => {
  const ColumnWidthMultiplier = 1.33 // used to increase the size of column widths which are sent back from the API
  const ColumnWidthBuffer = 6 // used to add additional buffer to the column widths
  const PageSize = 5000
  return {
    ColumnWidthMultiplier,
    ColumnWidthBuffer,
    PageSize
  }
})()

const DefaultSearchFilter = (() => {
  const categories = ['Workspace', 'Grid', 'Chart', 'Metric', 'Distribution', 'Trigger', 'Group', 'Discussion', 'User']
  const query = ''
  const start = 0
  const max = 10000
  const groupBy = ''
  const excludedTags = '' 
  const age = '' 
  const startDate = '' 
  const endDate = '' 
  const sort = 'Name' 
  const selectedUser = ''
  return {
    categories,
    query,
    start,
    max,
    groupBy,
    excludedTags, 
    age, 
    startDate, 
    endDate, 
    sort, 
    selectedUser
  }
})()

const SearchSettings = (() => {
  const minSearchTermLength = 2
  const paging = 20
  return {
    minSearchTermLength,
    defaultFilter: DefaultSearchFilter,
    paging
  }
})()

export const CONST = {
  Defaults,
  Services,
  ApiSettings,
  Cookies,
  Grid,
  ApiRequests,
  SearchSettings
}

export default CONST
